import { render } from "./ButtonView.vue?vue&type=template&id=2eda7f6c&scoped=true"
import script from "./ButtonView.vue?vue&type=script&lang=js"
export * from "./ButtonView.vue?vue&type=script&lang=js"

import "./ButtonView.vue?vue&type=style&index=0&id=2eda7f6c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2eda7f6c"]])

export default __exports__